<template>
    <v-container fluid>
        <v-progress-circular indeterminate v-bind:size="70" v-bind:width="7" class="purple--text"></v-progress-circular>

        <h1>Login ...</h1>
    </v-container>
</template>

<script>
    export default {
        name: 'login',
        data() {
            return {
                title: 'Login',
            };
        },
        created() {
            this.$store.commit('auth/AUTHORIZE');
        },
    };
</script>



// WEBPACK FOOTER //
// Login.vue?1222851e